import React from 'react';
import { Link } from 'react-router-dom';

const BlogCard = ({ post }) => {
    return (
        <Link
            to={`/blog/${post.slug}`}
            className="group bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300 block"
        >
            <div className="aspect-video overflow-hidden relative">
                <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
            </div>
            <div className="p-4">
                <h3 className="text-lg font-bold mb-2 text-gray-900 group-hover:text-brand-blue transition-colors duration-300 line-clamp-2">
                    {post.title}
                </h3>
                <div className="text-sm text-gray-400">
                    {post.date}
                </div>
            </div>
        </Link>
    );
};

export default BlogCard;
